var fowtr_module_scrollmagic = (function (fowtr_module_scrollmagic) {

     fowtr_module_scrollmagic.init = function(chapter){
      
      // console.log('fowtr_module_scrollmagic initialised for chapter '+chapter);

      // PARALLAX CONTROLLER
      // duration is 300% - meaning, if will 'do stuff' for 300% of the height - and as they are 100% height, that covers them 'coming in', 'in', and 'going out' of viewport

      fowtr_module_scrollmagic.controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          // triggerHook: "onEnter",
          // duration: "300%"
        }});

      //section 1 parallax
      new ScrollMagic.Scene({triggerElement: "#fowtr-article2", duration: "300%", triggerHook: "onEnter"})
              .setTween("#fowtr-article1 > .fowtr-parallax-bg", {y: "200%", opacity:0, ease: Linear.easeNone})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);

      //section 2 parallax
      new ScrollMagic.Scene({triggerElement: "#fowtr-article2", duration: "300%", triggerHook: "onEnter"})
              .setTween("#fowtr-article2 > .fowtr-parallax-bg", {y: "149%", ease: Linear.easeNone})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);



      // other standard on-scrolly actions etc

      // var triggeredController = new ScrollMagic.Controller({
      //   globalSceneOptions: {
      //     triggerHook: "onEnter",
      //     // duration: "100%"
      //   }});

        //section 1 text fade out
        $('#fowtr-article2 .fowtr-featured-text').css({
          'left':'-200px',
          'opacity':0
        });
        new ScrollMagic.Scene({triggerElement: "#fowtr-article2 .fowtr-featured-text", triggerHook: "onEnter"})
                // .setTween("#fowtr-article1 .fowtr-cover-headline", {css:{'line-height':'+=100px'}, opacity:0, ease: Linear.easeNone})
                .setTween("#fowtr-article2 .fowtr-featured-text", {left:'0px', opacity:1, ease: Power2.easeOut})
                // .addIndicators()
                .addTo(fowtr_module_scrollmagic.controller);



      // ANIMATED NUMBER 75%


      function animateNumber() {
        $(".fowtr-operations-stat span").each(function () {
          var $this = $(this),
            countTo = $this.attr("data-count");
          $({ countNum: $this.text() }).animate(
            {
              countNum: countTo
            },
            {
              duration: 1000,
              easing: "easeOutSine",
              step: function () {
                // Count up with commas
                $this.text(Math.floor(this.countNum).toLocaleString("en")+"%");
              },
              complete: function () {
                // Add comma after done counting
                $this.text(this.countNum.toLocaleString("en")+"%");
              }
            }
          );
        });
      }


      $('#fowtr-article3 .fowtr-operations-stat').css({
        'opacity':0
      });

      new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .fowtr-operations-stat", triggerHook: "onEnter"})
        .setTween("#fowtr-article3 .fowtr-operations-stat", 1, {opacity:1, ease: Power2.easeOut})
        .on("enter", function () {
          // $('#fowtr-article3 .fowtr-operations-stat').fadeIn(2000);
          // $(".section").addClass("pod--animated");
          animateNumber();
        })
        .on("leave", function () {
          // $('#fowtr-article3 .fowtr-operations-stat').hide();
          // $(".section").removeClass("pod--animated");
        })
        // .addIndicators()
        .addTo(fowtr_module_scrollmagic.controller);





        //section 3 columns
        $('#fowtr-article3 .col1').css({
          'left':'-200px',
          'opacity':0
        });
        $('#fowtr-article3 .col2').css({
          'left':'200px',
          'opacity':0
        });
        $('#fowtr-article3 .fowtr-quote::before').css({
          'scale':3,
          'opacity':0
        });
        new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .col1", triggerHook: "onEnter"})
                // .setTween("#fowtr-article1 .fowtr-cover-headline", {css:{'line-height':'+=100px'}, opacity:0, ease: Linear.easeNone})
                .setTween("#fowtr-article3 .col1", {left:'0px', opacity:1, ease: Power2.easeOut})
                // .addIndicators()
                .addTo(fowtr_module_scrollmagic.controller);

        new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .col2", triggerHook: "onEnter"})
                // .setTween("#fowtr-article1 .fowtr-cover-headline", {css:{'line-height':'+=100px'}, opacity:0, ease: Linear.easeNone})
                .setTween("#fowtr-article3 .col2", {left:'0px', opacity:1, ease: Power2.easeOut})
                // .addIndicators()
                .addTo(fowtr_module_scrollmagic.controller);





      // var standardController = new ScrollMagic.Controller({
      //   globalSceneOptions: {
      //     triggerHook: "onEnter",
      //     duration: "100%"
      //   }});
        //section 3 map
        $('#fowtr-article3 .fowtr-world-map').css({
          'transform':'scale(1.5)'
        });

        new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .fowtr-world-map", duration: "100%", triggerHook: "onEnter"})
          .setTween("#fowtr-article3 .fowtr-world-map", {scale:1, ease: Linear.easeNone})
          // .addIndicators()
          .addTo(fowtr_module_scrollmagic.controller);





        //section 3 man man2 woman
        $('#fowtr-article3 .fowtr-operations-man-1').css({
          'left':'-150px',
          'opacity':0,
        });

        new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .fowtr-operations-man-1", duration: "500px", triggerHook: "onEnter"})
          .setTween("#fowtr-article3 .fowtr-operations-man-1", {left:'-50px', opacity:1, ease: Linear.easeNone})
          // .addIndicators()
          .addTo(fowtr_module_scrollmagic.controller);

        $('#fowtr-article3 .fowtr-operations-man-2').css({
          'bottom':'150px',
          'opacity':0,
        });
        new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .fowtr-operations-man-2", duration: "500px", triggerHook: "onEnter"})
          .setTween("#fowtr-article3 .fowtr-operations-man-2", {bottom:'230px', opacity:1, ease: Linear.easeNone})
          // .addIndicators()
          .addTo(fowtr_module_scrollmagic.controller);

        $('#fowtr-article3 .fowtr-operations-woman').css({
          'right':'-200px',
          'opacity':0,
        });
        new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .fowtr-operations-woman", duration: "500px", triggerHook: "onEnter"})
          .setTween("#fowtr-article3 .fowtr-operations-woman", {right:'-100px', opacity:1, ease: Linear.easeNone})
          // .addIndicators()
          .addTo(fowtr_module_scrollmagic.controller);





      //section 5 parallax
      new ScrollMagic.Scene({triggerElement: "#fowtr-article5", duration: "300%", triggerHook: "onEnter"})
              .setTween("#fowtr-article5 > .fowtr-parallax-bg", {y: "149%", ease: Linear.easeNone})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);


      $('#fowtr-article5 .fowtr-h4').css({
        'transform':'scale(0.9)',
        'opacity':0,
      });

      new ScrollMagic.Scene({triggerElement: "#fowtr-article5", duration: "300px", offset:250, triggerHook: "onEnter"})
              .setTween("#fowtr-article5 .fowtr-h4", {opacity: 1, scale:1, ease: Power1.easeOut})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);

      $('#fowtr-article5 .fowtr-h5').css({
        'transform':'scale(0.9)',
        'opacity':0,
      });

      new ScrollMagic.Scene({triggerElement: "#fowtr-article5", duration: "300px", offset:300, triggerHook: "onEnter"})
              .setTween("#fowtr-article5 .fowtr-h5", {opacity: 1, scale:1, ease: Power1.easeOut})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);




      //section 6 parallax
      new ScrollMagic.Scene({triggerElement: "#fowtr-article6", duration: "300%", triggerHook: "onEnter"})
              .setTween("#fowtr-article6 > .fowtr-parallax-bg", {y: "149%", ease: Linear.easeNone})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);

      //section 6 overlay
      $('#fowtr-article6 .fowtr-black-overlay').css({'opacity':0});
      new ScrollMagic.Scene({triggerElement: "#fowtr-article6", duration: "100%", triggerHook: "onEnter"})
              .setTween("#fowtr-article6 > .fowtr-black-overlay", {opacity: 1, ease: Linear.easeNone})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);




      //section 7 parallax
      new ScrollMagic.Scene({triggerElement: "#fowtr-article7", duration: "300%", triggerHook: "onEnter"})
              .setTween("#fowtr-article7 > .fowtr-parallax-bg", {y: "149%", ease: Linear.easeNone})
              // .addIndicators()
              .addTo(fowtr_module_scrollmagic.controller);





        // $('#fowtr-article3 .fowtr-woman-yellow, #fowtr-article3 .fowtr-man-red, #fowtr-article3 .fowtr-woman-red, #fowtr-article3 .fowtr-man-red-2').css({
        //   'top':'50px',
        //   'opacity':0
        // });

        // new ScrollMagic.Scene({triggerElement: "#fowtr-article3 .fowtr-threeoutoffour"})
        //         // .setTween("#fowtr-article1 .fowtr-cover-headline", {css:{'line-height':'+=100px'}, opacity:0, ease: Linear.easeNone})
        //         .setTween("#fowtr-article3 .fowtr-woman-yellow", {top:'0px', opacity:1, ease: Power2.easeOut, delay:0})
        //         .setTween("#fowtr-article3 .fowtr-man-red", {top:'0px', opacity:1, ease: Power2.easeOut, delay:0.3})
        //         .setTween("#fowtr-article3 .fowtr-woman-red", {top:'0px', opacity:1, ease: Power2.easeOut, delay:0.6})
        //         .setTween("#fowtr-article3 .fowtr-man-red-2", {top:'0px', opacity:1, ease: Power2.easeOut, delay:0.9})
        //         // .addIndicators()
        //         .addTo(fowtr_module_scrollmagic.controller);




     };

    return fowtr_module_scrollmagic;
}(fowtr_module_scrollmagic || {}));